import React from 'react';
import styled from 'styled-components';
import Actions from './Actions';

const Wrapper = styled.div`
    position: sticky;
    top: 0;
    z-index: 1;
    height: 80px;
    width: 100%;
    padding: 25px;
    display: flex;
    justify-content: space-between;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
`
const TopBar: React.FC<{}> = (props) => {
    return (
        <Wrapper>
            &nbsp;
            <Actions />
        </Wrapper>
    );
}

export default TopBar;